export default function formatFilterForQuery(fieldId, activeFiltersForField, separator, prefix = '') {
  const key = `${prefix}${fieldId}`;
  const value = activeFiltersForField.map(filter => filter.get('value')).join(separator);
  return { [key]: value };
}
